import React, { useState } from "react";
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import LocationPopup from "./LocationPopup";
import {
  AdminPanelTitle,
  AdminMetric,
  AdminMainText,
  AdminSupportingText,
} from "../../sections/AdminDashboard/shared/adminUx";

const LocationWidget = ({ setFieldValue, values }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const fields = [
    { name: "Primary location", key: "primaryLocation", estimatedTime: "1 min", required: false },
  ];

  const sampleData = {
    primaryLocation: "Richmond",
  };

  const displayValues = {
    primaryLocation: values?.primaryLocation || sampleData.primaryLocation || "",
  };

  const calculateProgress = () => {
    const completedFields = fields.filter((field) => {
      const hasValue =
        displayValues[field.key] && displayValues[field.key].toString().trim() !== "";
      return hasValue;
    }).length;
    return Math.round((completedFields / fields.length) * 100);
  };

  const progress = calculateProgress();

  return (
    <>
      <DashboardMainContainer className="masonry-item w-[500px] h-auto account-widget">
        <div className="flex items-center justify-between py-3 px-4 border-b border-mediumgray">
          <AdminPanelTitle className="text-offblack">Location</AdminPanelTitle>
          <div className="flex items-center gap-2">
            <div className="w-16 h-1.5 bg-lightgray rounded-full overflow-hidden">
              <div
                className="h-full bg-freshgreen transition-all duration-500 ease-out"
                style={{ width: `${progress}%` }}
              />
            </div>
            <AdminMetric size="micro" className="text-offblack tabular-nums">
              {progress}%
            </AdminMetric>
          </div>
        </div>

        <div className="px-4 py-4">
          <div className="space-y-0">
            {fields.map((field, index) => {
              const hasValue =
                displayValues[field.key] && displayValues[field.key].toString().trim() !== "";

              return (
                <div
                  key={field.key}
                  className="group flex items-center w-full py-[4px] cursor-pointer hover:text-primaryblue rounded px-2 -mx-2"
                  onClick={() => setIsPopupOpen(true)}
                >
                  <AdminSupportingText
                    className={`w-40 shrink-0 ${index < fields.length - 1 ? "border-b border-lightgray pb-2" : ""} text-offblack group-hover:text-primaryblue`}
                  >
                    {field.name}
                  </AdminSupportingText>
                  <AdminMainText className="text-offblack group-hover:text-primaryblue truncate">
                    {hasValue ? displayValues[field.key] : "Not set"}
                  </AdminMainText>
                </div>
              );
            })}
          </div>
        </div>
      </DashboardMainContainer>

      {isPopupOpen && (
        <LocationPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          setFieldValue={setFieldValue}
          values={values}
        />
      )}
    </>
  );
};

export default LocationWidget;
